var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useEffect, useState } from "react";
// import useRadioStyles from "./Radio.styles";
import { useTheme } from "../ThemeProvider/ThemeProvider";
import styled from "styled-components";
var getSize = function (size) {
    switch (size) {
        case "small":
            return 0.875;
        case "medium":
            return 1;
        case "large":
            return 1.5;
    }
    return 1;
};
var StyledRadio = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  & input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n  }\n  & input[type=\"radio\"] + span {\n    position: relative;\n    width: ", "rem;\n    height: ", "rem;\n    border-radius: 50%;\n    border: ", ";\n  }\n  & input[type=\"radio\"]:checked + span {\n    width: ", "rem;\n    height: ", "rem;\n    border-radius: 50%;\n    position: relative;\n    border: ", ";\n  }\n  & input[type=\"radio\"]:checked + span:after {\n    content: \"\";\n    position: absolute;\n    width: 75%;\n    height: 75%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 50%;\n  & input[type=\"radio\"] {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n  }\n  & input[type=\"radio\"] + span {\n    position: relative;\n    width: ", "rem;\n    height: ", "rem;\n    border-radius: 50%;\n    border: ", ";\n  }\n  & input[type=\"radio\"]:checked + span {\n    width: ", "rem;\n    height: ", "rem;\n    border-radius: 50%;\n    position: relative;\n    border: ", ";\n  }\n  & input[type=\"radio\"]:checked + span:after {\n    content: \"\";\n    position: absolute;\n    width: 75%;\n    height: 75%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    background-color: ", ";\n  }\n"])), function (props) { return getSize(props.$size); }, function (props) { return getSize(props.$size); }, function (props) {
    return "1.5px solid ".concat(props.$colorGradient[props.$color].accentScale[8]);
}, function (props) { return getSize(props.$size); }, function (props) { return getSize(props.$size); }, function (props) {
    return "1.5px solid ".concat(props.$colorGradient[props.$color].accentScale[8]);
}, function (props) {
    return props.$colorGradient[props.$color].accentScale[8];
});
var Radio = forwardRef(function (_a, ref) {
    var _b = _a.index, index = _b === void 0 ? 0 : _b, _c = _a.value, value = _c === void 0 ? "" : _c, _d = _a.selected, selected = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, name = _a.name, id = _a.id, className = _a.className, style = _a.style, _f = _a.size, size = _f === void 0 ? "medium" : _f, _g = _a.color, color = _g === void 0 ? "primary" : _g, focused = _a.focused, 
    //Events
    onChange = _a.onChange, getSelectedIndex = _a.getSelectedIndex, props = __rest(_a, ["index", "value", "selected", "disabled", "name", "id", "className", "style", "size", "color", "focused", "onChange", "getSelectedIndex"]);
    var innerRef = React.useRef(null);
    var _ref = (ref !== null && ref !== void 0 ? ref : innerRef);
    var _h = useState(selected), isSelected = _h[0], setIsSelected = _h[1];
    useEffect(function () {
        setIsSelected(selected);
    }, [selected, focused]);
    var colorPalette = useTheme().theme.colorPalette;
    // Events
    var _onChange = function (event) {
        if (isSelected)
            return;
        // setIsSelected(event.target.checked);
        getSelectedIndex && getSelectedIndex(index);
        onChange && onChange(event);
    };
    return (_jsxs(StyledRadio, __assign({ role: "radio", "$selected": isSelected, "$disabled": disabled, "$size": size, "$color": color, "$colorGradient": colorPalette, "aria-checked": isSelected, className: "".concat(className) }, props, { children: [_jsx("input", { ref: _ref, type: "radio", checked: isSelected, name: name, onChange: _onChange }), _jsx("span", {})] })));
});
export default React.memo(Radio);
var templateObject_1;
